<section class="mainSection home-page-banner">
    <div class="container">
        <div class="row">
            <div class="col-xl-7 col-lg-7 text-left">
                <div class="left">
                    <h4>INVESTMENT BANKING
                    </h4>
                    <h2>Investment Bankers for new India
                    </h2>
                    <h3>Grow with our best-in-class advice and
                        <br /> execution excellence
                    </h3>
                </div>
            </div>
            <div class="col-xl-5 col-lg-5 col-sm-12 userForm-sec d-none">
                <div class="userForm" *ngIf="!formSubmitted">
                    <form autocomplete="off" [formGroup]="createLeadForm" (ngSubmit)="createLead()">
                        <h2>Let's connect today to nuture your business  with Bajaj Capital </h2>
                        <div class="form-group required">
                            <label for="name">Full Name</label>
                            <input type="text" formControlName="Name" id="name" name="name" class="form-control" placeholder="Please enter your full name" maxlength="40" (keydown)="alphaOnly($event)" (blur)="removeErrorMsg('name')" >
                            <div class="errormsg" *ngIf="nameValidateMessage == 'lengthError'">
                                Invalid full name
                            </div>
                            <div class="errormsg" *ngIf="nameValidateMessage == 'required'">
                                Full name is mandatory
                            </div>
                        </div>
                        <div class="form-group required">
                            <label for="company">Company Name</label>
                            <input type="text" id="company" name="company" formControlName="Company" class="form-control"  placeholder="Enter your company name" maxlength="40" (blur)="removeErrorMsg('company')" (keydown)="alphaOnly($event)" >
                            <div class="errormsg" *ngIf="companyValidateMessage == 'lengthError'">
                                Invalid company name
                            </div>
                            <div class="errormsg" *ngIf="companyValidateMessage == 'required'">
                                Company name is mandatory
                            </div>
                        </div>
                        <div class="form-group required">
                            <label for="email">Email ID</label>
                            <input type="text" formControlName="Email"  (keydown.space)="$event.preventDefault();"  id="email" name="email" class="form-control" placeholder="Your email id" maxlength="50" (blur)="removeErrorMsg('email')">
                            <div class="errormsg"  *ngIf="emailValidateMessage == 'invalid'">
                                Invalid email id
                            </div> 
                            <div class="errormsg"  *ngIf="emailValidateMessage == 'required'">
                                Email id is mandatory
                            </div>  
                        </div>
                        <div class="form-group required">
                            <label for="mobile">Mobile Number</label>
                            <input type="text" formControlName="Mobile" (keydown.space)="$event.preventDefault();" id="mobile" name="mobile" class="form-control" placeholder="Enter Your mobile number" minlength="10" maxlength="10"  pattern="[6789][0-9]{9}" (blur)="removeErrorMsg('mobile')" (keydown)="numbersOnly($event)">
                            <div class="errormsg" *ngIf="mobileValidateMessage == 'lengthError'">
                                10 digit mobile number is mandatory
                            </div>
                            <div class="errormsg" *ngIf="mobileValidateMessage == 'invalid'">
                              Invalid mobile number
                            </div>
                            <div class="errormsg" *ngIf="mobileValidateMessage == 'required'">
                                Mobile number is mandatory
                            </div>
                        </div>
                        <div class="form-group text-center">
                            <button type="submit" class="btn btn-primary" id="continue_btn" (click)="checkValidationMsg(createLeadForm)">Submit</button><br>
                            <small>By continuing, you provide consent and agree to our <a [routerLink]="['/term-conditions']" [queryParams]="{doc:'tnc'}"  > Terms & Conditions</a> </small>
                        </div>
                    </form>
                </div>
                <div class="thank_you" *ngIf="formSubmitted">
                    <div class="tick">
                        <img src="../../assets/images/home/check.png" class="img-fluid" alt="check">
                    </div>
                    <div class="content">
                        <p class="text-1">Thank you</p>
                        <small class="text-2">Your form has been successfully submitted. We will get in touch with you soon.
                        </small>
                    </div>
                  </div>
            </div>
        </div>
    </div>
</section>
<section class="bajajKeyPoints">
    <div class="container">
    </div>
</section>
<div class="whyBajajCapital">
    <div class="container">
        <div class="row d-none">
            <div class="col-12 col-xl-4 col-lg-4">
                <div class="keyCard">
                    <p>One of the
                        <strong> most experienced merchant banking
                        </strong> outfits in India
                    </p>
                </div>
            </div>
            <div class="col-12 col-xl-4 col-lg-4">
                <div class="keyCard">
                    <p>Managed over
                        <strong>₹25,000 crore
                        </strong>Capital Market fund raise
                    </p>
                </div>
            </div>
            <div class="col-12 col-xl-4 col-lg-4">
                <div class="keyCard">
                    <p>We adopt a
                        <strong> client-centric
                        </strong>solution-driven approach
                    </p>
                </div>
            </div>
        </div>
        <div class="row whyReasons">
            <div class="col-xl-6 col-lg-6 left">
                <h2>Why BajajCapital Securities Limited?
                </h2>
                <p>Corporate Advisory & Fund Raising solutions for YOU
                </p>
                <p>We assist you with the right set of valuation, cost, onus & team.
                </p>
                <ul>
                    <li>Strong Market Proposition
                    </li>
                    <li>Long Term Partner
                    </li>
                    <li>Advises Optimal Fit
                    </li>
                    <li>Holistic Solutions
                    </li>
                </ul>
            </div>
            <div class="col-xl-6 col-lg-6">
                <div class="card">
                    <img src="../../assets/images/home/whyImg.png" />
                    <p class="d-none">Our Investment banking vertical is one of the oldest in the country - ranked 9th for Debt
                        Public Issues & ranked 15th for Equity & Debt Public Issues managed over the past 2 decades.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
<section class="ourVision d-none">
    <div class="container">
        <div class="row">
            <div class="col-xl-6 col-lg-6">
                <div class="visionPOint">
                    <span class="image">
                        <img src="../../assets/images/home/nuron.png" />
                    </span>
                    <p>Our vast network of clients and investors along with impeccable service and solutions for
                        each client, has laid the foundation for our wealth creation legacy!
                    </p>
                </div>
            </div>
            <div class="col-xl-6 col-lg-6">
                <div class="visionPOint">
                    <span class="image">
                        <img src="../../assets/images/home/user.png" />
                    </span>
                    <p>We service varied class of corporates, investors, fund houses, institutions, family offices
                        etc.</p>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="intigratedProduct">
    <div class="container">
        <div class="row">
            <div class="col-xl-12 col-lg-12">
                <h2 class="text-center">Integrated products bouquet across
                    <strong>Equity & Debt
                    </strong>
                </h2>
            </div>
        </div>
        <div class="row">
           
            <div class="col-xl-6 col-lg-6 right">
                <h3>
                    <img src="../../assets/images/home/icon-park.png" />Private
                    Funding
                </h3>
                <div class="productCardWrapper">
                    <div class="productCard">
                        <strong>Structured Finance</strong>
                        <p>Special Situation, Stress Funding, Acquisition Finance, Mezzanine Finance & Promotor
                            Funding
                        </p>
                    </div>
                    <div class="productCard">
                        <strong>Debt Syndication</strong>
                        <p>Project Finance, Trade Finance, Foreign Debt & Foreign Bonds
                        </p>
                    </div>
                    <div class="productCard">
                        <strong>PE and M&A</strong>
                        <p>Venture Capital, PE, PIPE, Divestments, M&A Strategic Stoke & JV's
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-12 col-lg-12 col-12 offerDoc">
                <!-- <h2 class="text-center"><strong>Transactions</strong>
                </h2> -->
            </div>
        </div>
        <div class="row">
            <div class="col-xl-12 col-lg-12 col-12 offerDoc">
                <!-- <h2 class="text-center"><strong>OFFER DOCUMENTS</strong>
                </h2> -->
                <br><br>
                <div class="new">
                    <ul class="nav nav-tabs" id="myTab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link" id="home-tab" data-bs-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Track Record of the public issues
                                managed</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link active" id="profile-tab" data-bs-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">Investor Charter</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="contact-tab" data-bs-toggle="tab" href="#contact" role="tab" aria-controls="contact" aria-selected="false">Disclosure of data on complaints <br> (Investor grievances data)</a>
                        </li>
                    </ul>

                    <div class="tab-content" id="myTabContent">
                        <div class="tab-pane fade" id="home" role="tabpanel" aria-labelledby="home-tab">
                            <br>
                            <a href="../../assets/pdf/track-record-of-issues-handled.pdf">Track record of issues handled</a>
                        </div>
                        <div class="tab-pane fade show active" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                            <br>
                            <br>


                            <!-- <li class="showMore"
                            style="list-style:none; cursor:pointer;margin: 10px 0 0 0px; text-decoration: underline;">
                            Show more
                        </li> -->
                            <ul class="sublistPDFq" style="padding:0 0 0 20px;">
                                <p style="margin-left: -20px;">Charters for Investors’ Awareness issued by SEBI</p>
                                <li>
                                    <a href="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Shashank/investment-landing-page/assets/Annexure+-+A+Charters+for+Investors%E2%80%99+Awareness+issued+by+SEBI/Investor+charter+-+Delisting+of+Equity+Shares.pdf" style="color: #FD4C5C;" target="_blank">Investor charter - Delisting of
                                        Equity
                                        Shares
                                    </a>
                                </li>
                                <li>
                                    <a href="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Shashank/investment-landing-page/assets/Annexure+-+A+Charters+for+Investors%E2%80%99+Awareness+issued+by+SEBI/Investor+charter+-+IPOs+and+FPOs+including+OFS.pdf" style="color: #FD4C5C;" target="_blank">Investor charter - IPOs and FPOs
                                        including OFS
                                    </a>
                                </li>
                                <li>
                                    <a href="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Shashank/investment-landing-page/assets/Annexure+-+A+Charters+for+Investors%E2%80%99+Awareness+issued+by+SEBI/Investor+charter+-+Preferential+Issue.pdf" style="color: #FD4C5C;" target="_blank">Investor charter - Preferential
                                        Issue
                                    </a>
                                </li>
                                <li>
                                    <a href="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Shashank/investment-landing-page/assets/Annexure+-+A+Charters+for+Investors%E2%80%99+Awareness+issued+by+SEBI/Investor+charter+-+Private+Placement+of+Municipal+Debt+Securities.pdf" style="color: #FD4C5C;" target="_blank">Investor charter - Private Placement
                                        of
                                        Municipal Debt Securities
                                    </a>
                                </li>
                                <li>
                                    <a href="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Shashank/investment-landing-page/assets/Annexure+-+A+Charters+for+Investors%E2%80%99+Awareness+issued+by+SEBI/Investor+charter+-+Private+Placement+of+Non-Convertible+Securities.pdf" style="color: #FD4C5C;" target="_blank">Investor charter - Private Placement
                                        of
                                        Non-Convertible Securities
                                    </a>
                                </li>
                                <li>
                                    <a href="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Shashank/investment-landing-page/assets/Annexure+-+A+Charters+for+Investors%E2%80%99+Awareness+issued+by+SEBI/Investor+charter+-+Private+Placement+of+units+by+InvITs.pdf" style="color: #FD4C5C;" target="_blank">Investor charter - Private Placement
                                        of
                                        units by
                                        InvITs
                                    </a>
                                </li>
                                <li>
                                    <a href="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Shashank/investment-landing-page/assets/Annexure+-+A+Charters+for+Investors%E2%80%99+Awareness+issued+by+SEBI/Investor+charter+-+Public+Issue+of+Debt+Securities.pdf" style="color: #FD4C5C;" target="_blank">Investor charter - Public Issue of
                                        Debt
                                        Securities
                                    </a>
                                </li>
                                <li>
                                    <a href="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Shashank/investment-landing-page/assets/Annexure+-+A+Charters+for+Investors%E2%80%99+Awareness+issued+by+SEBI/Investor+charter+-+Public+issue+of+InvITS.pdf" style="color: #FD4C5C;" target="_blank">Investor charter - Public issue of
                                        InvITS
                                    </a>
                                </li>
                                <li>
                                    <a href="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Shashank/investment-landing-page/assets/Annexure+-+A+Charters+for+Investors%E2%80%99+Awareness+issued+by+SEBI/Investor+charter+-+Public+Issue+of+Non-Convertible+Redeemable+Preference+Shares(NCRPs).pdf" style="color: #FD4C5C;" target="_blank">Investor charter - Public Issue of
                                        Non-Convertible Redeemable Preference Shares(NCRPs)
                                    </a>
                                </li>
                                <li>
                                    <a href="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Shashank/investment-landing-page/assets/Annexure+-+A+Charters+for+Investors%E2%80%99+Awareness+issued+by+SEBI/Investor+charter+-+Public+Issue+of+REITs.pdf" style="color: #FD4C5C;" target="_blank">Investor charter - Public Issue of
                                        REITs
                                    </a>
                                </li>
                                <li>
                                    <a href="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Shashank/investment-landing-page/assets/Annexure+-+A+Charters+for+Investors%E2%80%99+Awareness+issued+by+SEBI/Investor+charter+-+Qualified+Institutionsplacement+(QIPs).pdf" style="color: #FD4C5C;" target="_blank">Investor charter - Qualified
                                        Institutionsplacement (QIPs)
                                    </a>
                                </li>
                                <li>
                                    <a href="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Shashank/investment-landing-page/assets/Annexure+-+A+Charters+for+Investors%E2%80%99+Awareness+issued+by+SEBI/Investor+charter+-+SME+IPOs+and+FPOs+(including+OFS).pdf" style="color: #FD4C5C;" target="_blank">Investor charter - SME IPOs and FPOs
                                        (including
                                        OFS)
                                    </a>
                                </li>
                                <li>
                                    <a href="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Shashank/investment-landing-page/assets/Annexure+-+A+Charters+for+Investors%E2%80%99+Awareness+issued+by+SEBI/Investor+charter+-+Substantial+Acquisition+of+Shares+and+Takeovers.pdf" style="color: #FD4C5C;" target="_blank">Investor charter - Substantial
                                        Acquisition of
                                        Shares and Takeovers
                                    </a>
                                </li>
                                <li>
                                    <a href="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Shashank/investment-landing-page/assets/Annexure+-+A+Charters+for+Investors%E2%80%99+Awareness+issued+by+SEBI/Investor+charter-+Rights+Issue.pdf" style="color: #FD4C5C;" target="_blank">Investor charter- Rights Issue
                                    </a>
                                </li>
                                <li>
                                    <a href="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Shashank/investment-landing-page/assets/Annexure+-+A+Charters+for+Investors%E2%80%99+Awareness+issued+by+SEBI/Investor+charter+-+Buyback+of+Securities.pdf" style="color: #FD4C5C;" target="_blank">Investor-charter - Buyback of
                                        Securities
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="professional">
    <div class="container text-center">
        <div class="row">
            <div class="col-xl-12 col-lg-12">
                <h2 class="text-center">Seasoned Investment Banking Professionals with
                    <strong> Deep Investor Connect</strong>
                </h2>
            </div>
        </div>
        <div class="executive-profiles">
            <div class="profile-card">
                <img src="../../assets/images/home/sb.png" alt="Mr. Sanjiv Bajaj" class="profile-image">
                <h3 class="name">Mr. Sanjiv Bajaj</h3>
                <p class="title">Director</p>
        
                <ul class="details">
                    <li>Over 25 years of experience</li>
                    <li>Certified Financial Planner (CFP) and MBA (Finance)</li>
                    <li>Hosts Financial talk show- FINtastic Talks with 6 Lacs plus Unique viewership</li>
                </ul>
            </div>
            <div class="profile-card">
                <img src="../../assets/images/home/rb.png" alt="Mr. Rajiv Bajaj" class="profile-image">
                <h3 class="name">Mr. Rajiv Bajaj</h3>
                <p class="title">Director</p>
        
                <ul class="details">
                    <li>Over 30 years of experience</li>
                    <li>Holds strategic management experience in the fields of Investment Banking, Investment Advisory,
                        Insurance Brokerage, Financial Planning</li>
                </ul>
            </div>
            <div class="profile-card">
                <img src="../../assets/images/home/prashant.png" alt="Mr T R Prashanth Kumar" class="profile-image">
                <h3 class="name">Mr. T R Prashanth Kumar</h3>
                <p class="title">WTD & CEO</p>
                <ul class="details">
                    <li>Over 3 decades of experience</li>
                    <li>Professional seasoned Investment Banker</li>
                    <li>Worked with Banks like Enam, KARVY, SBICAPS, Edelweiss, IL&FS & BOBCAPS</li>
                </ul>
            </div>
        </div>
    </div>
</section>
<section class="associateSection">
    <div class="container">
        <div class="row">
            <div class="col-xl-12 col-lg-12">
                <h2 class="text-center">
                    Investment Banking associations at
                    <strong>BajajCapital
                    </strong>
                </h2>
            </div>
        </div>
    </div>
</section>
<section class="corporateLocations">
    <div class="container">
        <div class="row">
            <div class="col-12 left">
                <img src="../../assets/images/home/map-pin.png" />
                <p>Reach out to us at </p>
            
            </div>
            <div class="col-12">
                <ul>
                    <li>Mezzanine Floor, 97, Bajaj House, Nehru Place, New Delhi – 110019, India
                    </li>
                    <li class="phone">
                        <i class="fas fa-phone-alt"></i>
                        <a href="tel:+919820645377">+91 98206 45377</a>
                    </li>
                   
                </ul>
            </div>
        
        </div>
    </div>
</section>
